// Contant texts
import { strings } from "i18n/Strings";

export const fundDetailsConstants = {
  fundNameField: 'fundName',
  totalUnitsField: 'totalUnits',
  symbolField: 'symbol',
  unitsValueField: 'unitsValue',
  clientUnitsField: 'clientUnits',
  mmUnitsField: 'mmUnits',
  todayPrice: 'todayPrice',
  closePrice: 'closePrice'
};

export const allocationDetails = {
  id: 'id',
  totalUnitsAllocated: 'totalUnitsAllocated',
  percentageAllocation: 'percentage_allocation',
  fundPercentageAllocation: 'fundPercentageAllocation',
  fundMatricesPercentage: 'fundMatricesPercentage',
  ageGroup: 'ageGroup',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  name: 'name',
}
export const holdingConstants = {
  contractId: 'contractId',
  fundId: 'fundId',
  fundName: 'fundName',
  totalUnitsAllocated: 'totalUnitsAllocated',
  currentPrice: 'currentPrice',
  totalValue: 'totalValue',
  closePrice: 'closePrice'
}
export const transactionDetailsConstants = {
  idField: 'id',
  orderTypeField: 'transactionMethod',
  totalContributionField: 'totalContribution',
  statusField: 'transactionStatus',
  dateField: 'transactionDate',
  fundName: 'fundDescription',
  fundType: 'fundType',
  totalUnits: 'totalUnits',
  orderId: 'orderId',
  filledDateField: 'filledDate',
  settlementDateField: 'settlementDate'
};

export const userWiseContributionConstants = {
  userIdField: 'userId',
  userNameField: 'firstName',
  totalField: 'splitAmount',
};

export const planWiseContributionConstants = {
  planNameField: 'planName',
  contributionField: 'contribution',
};


export const customerChatsConstants = {
  employee: 'employee',
  conversation: 'conversation',
  z: 'Z',
  customer: 'customer',
  complaint: 'complaint',
}

export const salesOrderConstants = {
  userId: 'userId',
  name: 'name',
  symbol: 'symbol',
  units: 'units',
  placeAndPreviewOrder: 'placeAndPreviewOrder',
  sell: 'SELL',
  sumbmitted: 'Submitted'
}
export const userWithdrawalRequestConstants = {
  withdrawalFund1Unit: 'withdrawalFund1Unit',
  withdrawalFund2Unit: 'withdrawalFund2Unit',
  withdrawalCashUnit: 'withdrawalCashUnit'
}


export const commonRegex = {
  emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/
};

export const transactionTabs = [
  { label: "All", value: 'all' },
  { label: "Contribution", value: 'contribution' },
  { label: "Fees", value: 'fees' },
]
export const roles = {
  MMAdminRole: 'mm_admin',
  MMEmployeeRole: 'mm_employee',
  OrganizationAdminRole: 'organization_admin',
  OrganizationEmployeeRole: 'organization_employee',
  CustomerRole: 'customer',
  CeoRole: 'ceo',
  AuditorRole: 'auditor',
}

export const roleIds = {
  MMAdminRoleId: '1',
  MMEmployeeRoleId: '2',
  OrganizationAdminRoleId: '3',
  OrganizationEmployeeRoleId: '4',
  CustomerRoleId: '5',
  CeoRoleId: '6',
  AuditorRole: '7',
}


export const orgAdminConstants = {
  notRegistered: 'Not Registered'
}

export const customerDetailsTabs: string[] = [
  "personalDetailsTab",
  "lifetimeGoalTab",
  "planDetailsTab",
  "transactionsTab",
  'holdings',
  "pensionAggregateTab",
  "chatsTab",
  "DocumentsTab",
  "complaintsRaisedTab",
];


export const commonConstantTexts = {
  evenText: "even",
  oddText: "odd",
  complaintsPage: "complaints",
  planChangeRequestsPage: "planChangeRequests",
  withdrawalRequestsPage: "withdrawalRequests",
  transferInRequestPage: "transferInRequests",
  transferOutRequestPage: "transferOutRequests",
  chatsPage: "chats",
  allTransaction: "allTransaction",
  approved: "Approved",
  rejected: "Rejected",
  firstName: "firstName",
  lastName: "lastName",
  email: "email",
  close: 'close',
  dateFormat: 'DD-MM-YYYY',
  contributionsPage: "contributions",
  leaver: "Leaver",
  registered: "Registered",
  notRegistered: 'Not Registered',
  success: 'Success',
  reconciled: 'Reconciled',
  nonReconciled: "Non Reconciled",
  otherPayments: "Other Payments",
  manual: 'Manual',
  automatic: 'Automatic',
  reconcilation: 'Reconcilation',
  manualReconciltion: 'Manual Reconcilation',
  markedAsManual: 'This transaction has been reconciled manually by Zen Pensions Admin from changing the transaction narrative ',
  reconciledByFollwing: 'This transaction has been reconciled by matching the following statements',
  withdrawalLabel: 'Withdrawal',
  transferOutLabel: 'Transfer Out',
  monthlyChargeLable: 'Monthly charge',
  deleted: 'Deleted',
}


export const orgEmployeeConstants = {
  orgEmpId: 'orgEmpId',
  empId: 'empId',
  leaver: 'Leaver',
  notRegistered: 'Not Registered',
  registered: 'Registered'

}

export const addEmployerConstantTexts = {
  companyName: "companyName",
  payrollFrequency: 'payrollFrequency',
  regEmail: "regEmail",
  regPhoneNumber: "regPhoneNumber",
  regAddress: "regAddress",
  regStreetOne: "regStreetOne",
  regStreetTwo: "regStreetTwo",
  regStreetThree: "regStreetThree",
  regCity: "regCity",
  regState: "regState",
  regCountry: "regCountry",
  regPostalCode: "regPostalCode",
  sameAsAbove: "sameAsAbove",
  tradingEmail: "tradingEmail",
  tradingPhoneNumber: "tradingPhoneNumber",
  tradingAddress: "tradingAddress",
  tradingStreetOne: "tradingStreetOne",
  tradingStreetTwo: "tradingStreetTwo",
  tradingStreetThree: "tradingStreetThree",
  tradingCity: "tradingCity",
  tradingState: "tradingState",
  tradingCountry: "tradingCountry",
  tradingPostalCode: "tradingPostalCode",
  employerTaxDetails: 'employerTaxDetails',
  employerBankAccountName: 'employerBankAccountName',
  employerBankAccountNumber: 'employerBankAccountNumber',
  payrollDate: 'payrollDate',
  comments: 'comments',
  firstName: "firstName",
  lastName: "lastName",
  email: "email",
  phone: "phone",
  gender: 'gender',
  maritalStatus: 'maritalStatus',
  economicStatus: 'economicStatus',
  economicOccupation: 'economicOccupation',
  pepType: 'pep Type',
  addEmployer: "Add Employer"
}


export const customerComplaintConstants = {
  complaintId: 'complaintId',
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  status: 'status',
  image: 'Image'
}
export const senderTypes = {
  employee: 'employee'
}

export const employeeStatusOptions = [
  { label: "Not Registered", value: 'Not Registered', disable: false },
  { label: "Registered", value: 'Registered', disable: false },
  { label: "Leaver", value: 'Leaver', disable: false },
]

export const activeStatusOptions = [
  { label: "Unblock", value: 'unblock' },
  { label: "Block", value: 'block' },
  { label: "Close", value: 'close' },
]

export const chatSearchColumns = ["userId", "userName", "messages", "status"]

export const groupChatContants = {
  allUser: 'All User',
  selectEmployers: 'Select Employers',
  selectEmail: 'Select Email'
}

export const fundDetailsTabDetails = {
  fundDetails: 'Fund Details',
  tradesHistory: 'Trades History',
  mmUnitSalesHistory: 'ZP Unit History'
}

export const genderOptions = [
  { label: "Male", value: 'male' },
  { label: "Female", value: 'female' },
  { label: "Other", value: 'other' }
];


export const maritalStatusOptions = [
  { label: "Single", value: 'single' },
  { label: "Married", value: 'married' },
  { label: 'Civil Partnership', value: 'civilPartnership' }
];

export const pepTypeOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const payrollFrequencyOptions = [
  { label: "Weekly", value: 'weekly' },
  { label: "Fortnightly", value: 'fortnightly' },
  { label: "Monthly", value: 'monthly' },
  { label: "Adhoc Once", value: 'adhocOnce' },
  { label: "Adhoc Yearly", value: 'adhocYearly' },

];

export const bankFileStatusOptions = [
  { label: "Reconciled", value: 'Reconciled', disabled: false },
  { label: "Non Reconciled", value: 'Non Reconciled', disabled: false },
  { label: "Other Payments", value: 'Other Payments', disabled: false },
]

export const statusOptions = [
  { value: "All", label: "All" },
  { value: "PendingSubmit", label: "Pending" },
  { value: "Submitted", label: "Submitted" },
  { value: "Filled", label: "Filled" },
  { value: "Cancelled", label: "Cancelled" }
];

export const transactionTypeOptions = [
  { value: "All", label: "All" },
  { value: "BUY", label: "Buy" },
  { value: "SELL", label: "Sell" }
];

export const transactionTypes = {
  contributions: 'Contributions',
  sell: 'Sell',
  buy: 'Buy',
  fees: 'Fees',
  monthlyCharge: 'Monthly Charge',
  buyOrder: 'Buy Order',
  sellOrder: 'Sell Order',
  reAllocation: 'Re-Allocation',
};

export const contributionFileStatus = [
  { value: "", label: "Clear" },
  { value: "Success", label: "Reconciled" },
  { value: "Rejected", label: "Non Reconciled - R" },
  { value: "Pending", label: "Non Reconciled - P" },
  { value: "Deleted", label: "Deleted" },
]


export const transferInFileStatus = [
  { value: "", label: "Clear" },
  { value: "Success", label: "Reconciled" },
  { value: "Pending", label: "Non Reconciled" },
]

export const payrollFrequencyFilterOptions = [
  { value: "", label: "Clear" },
  ...payrollFrequencyOptions
];

export const unitsStepValue = '0.0000001';


export const fundTypeOption = [
  { value: "", label: "Clear" },
  { value: "bond", label: "Bond" },
  { value: "cash", label: "Cash" },
  { value: "equity", label: "Equity" },
]

export const orderTypeOption = [
  { value: "", label: strings.displayText.clear },
  { value: "BUY", label: strings.displayText.buy },
  { value: "SELL", label: strings.displayText.sell },
  { value: "Fees", label: strings.displayText.charges },
  { value: "Re-Allocation", label: strings.displayText.contributionAdjustment },
]
export const transStatusTypeOption = [
  { value: "", label: "Clear" },
  { value: "processing", label: "Processing" },
  { value: "done", label: "Done" },
]

export const widrawalStatusTypeOption = [
  { value: "", label: "Clear" },
  { value: "New", label: "New" },
  { value: "In-progress", label: "In-Progress" },
  { value: "Payment Pending", label: "Payment Pending" },
  { value: "Rejected", label: "Rejected" },
  { value: "Closed", label: "Closed" },
]

export const complaintStatusTypeOption = [
  { value: "", label: "Clear" },
  { value: "New", label: "New" },
  { value: "In Process", label: "In Process" },
  { value: "Re-open", label: "Re-Open" },
  { value: "Close", label: "Close" },
];

export const chatStatusTypeOption = [
  { value: "", label: "Clear" },
  { value: "new", label: "New" },
  {
    value: "In Process", label: "In Process"
  },
];

export const planChangeStatusTypeOption = [
  { value: "", label: "Clear" },
  { value: "Approved", label: "Approved" },
  {
    value: "Pending", label: "Pending"
  },
  {
    value: "Rejected", label: "Rejected"
  },
];

export const exportExcelFileNames = {
  CUSTOMER_EXPORT: 'ZP_Customers.xlsx',
  ORDERS_IN_DETAIL: 'Orders_In_Detail.xlsx',
  ORDERS_HISTORY: 'Orders_History.xlsx',
  ORDER_SUMMARY: 'Orders_Summary.xlsx',
  ALL_EMPLOYEES: 'All_Employees.xlsx',
  BANK_FILE_REPORT: 'Bank_File_Record_Report.xlsx',
  MONTH_WISE_HOLDINGS: 'Month_Wise_Holdings.xlsx',
  COMPLAINTS: 'Complaints.xlsx',
  FUND_DETAILS: 'Fund_Details.xlsx',
  RE_ALLOCATION_DATA: 'Re_Allocation_Data.xlsx',

}

export const transactionOrderTypeOption = [
  { value: "Fees", label: strings.displayText.charges },
  { value: "Buy", label: strings.displayText.buy },
  { value: "Sell", label: strings.displayText.sell },
  { value: "Re-Allocation", label: strings.displayText.contributionAdjustment },
  { value: "", label: strings.displayText.clear },
]

export const transactionFilterOptions = [
  ...transactionOrderTypeOption
];


export const onBoardRequestType = {
  onboarding: 'ONBOARDING',
  avc: 'FundingLimitCheck'
}